function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import { Col, Row } from 'react-bootstrap';
import { EVENT_TYPE_BIRTH } from '../api';
import { extractPeriodFromData } from '../form';
import { useFormContext } from '../state/form';
import { SettingsButton } from './SettingsButton';
import { GeographyVisualization } from './GeographyVisualization';
import { PermalinkButton } from './PermalinkButton';
import { TimeVisualization } from './TimeVisualization';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function BlockResultTabStatistics() {
  var _useFormContext = useFormContext(),
      _useFormContext$state = _useFormContext.state,
      form = _useFormContext$state.form,
      _useFormContext$state2 = _useFormContext$state.statsGeography,
      isGeographyLoading = _useFormContext$state2.loading,
      statsGeographyData = _useFormContext$state2.data,
      _useFormContext$state3 = _useFormContext$state.statsTime,
      isTimeLoading = _useFormContext$state3.loading,
      statsTimeData = _useFormContext$state3.data;

  var geographyQueryString = form !== null && [form.surname, form.givenName].map(function (s) {
    return (s || '').trim();
  }).filter(function (s) {
    return s;
  }).join(' ');

  var _extractPeriodFromDat = extractPeriodFromData(form),
      _extractPeriodFromDat2 = _slicedToArray(_extractPeriodFromDat, 2),
      yearAfter = _extractPeriodFromDat2[0],
      yearBefore = _extractPeriodFromDat2[1];

  return /*#__PURE__*/_jsxs("div", {
    className: "block block-tab py-2 px-2",
    children: [/*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        className: "pr-0",
        children: /*#__PURE__*/_jsx(PermalinkButton, {
          isTabStats: true
        })
      }), /*#__PURE__*/_jsx(Col, {
        className: "text-right pl-0",
        children: /*#__PURE__*/_jsx(SettingsButton, {})
      })]
    }), /*#__PURE__*/_jsx(GeographyVisualization, {
      isLoading: isGeographyLoading,
      data: statsGeographyData !== null ? statsGeographyData.results : null,
      queryString: geographyQueryString
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        xs: {
          offset: 1,
          span: 10
        },
        md: {
          offset: 2,
          span: 8
        },
        lg: {
          offset: 3,
          span: 6
        },
        children: /*#__PURE__*/_jsx("hr", {})
      })
    }), /*#__PURE__*/_jsx(TimeVisualization, {
      isLoading: isTimeLoading,
      data: statsTimeData !== null ? statsTimeData.results : null,
      isBirth: form.sortBy === EVENT_TYPE_BIRTH,
      yearAfter: yearAfter != null && yearAfter.length > 0 ? parseInt(yearAfter) : null,
      yearBefore: yearBefore != null && yearBefore.length > 0 ? parseInt(yearBefore) : null
    })]
  });
}